<template>
	<div class="segmented-control" role="tabpanel">
		<ja-button
			v-for="(option, name) in options"
			:key="name"
			class="transparent"
			:name="name"
			role="tab"
			:aria-selected="(name == value).toString()"
			:class="['segment', { active: name == value }]"
			:style="{ width: calculateWidth() }"
			@click.native="clickSegment(name)"
		>
			{{ $t(option) }}
		</ja-button>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';

export default {
	components: {
		jaButton: Button
	},
	props: {
		options: {
			type: Object,
			default: null
		},
		value: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			controlWidth: 100 //percents
		};
	},
	methods: {
		clickSegment(name) {
			this.$emit('input', name);
		},
		calculateWidth() {
			return this.controlWidth / Object.keys(this.options).length + '%';
		}
	}
};
</script>
<style lang="scss">
.segmented-control {
	display: flex;
	height: 40px;
	width: 100%;
	border-radius: 4px;
	justify-content: center;
	font-family: 'RobotoMedium';
	font-size: 14px;
	line-height: 16px;
	letter-spacing: 0.54px;

	.segment {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		color: $primary-state;
		border-top: 2px solid $container-border;
		border-bottom: 2px solid $container-border;
		padding: 0 16px;
		text-align: center;
		border-radius: 0;

		&:first-child {
			border-left: 2px solid $container-border;
			border-radius: 4px 0 0 4px;
		}

		&:last-child {
			border-right: 2px solid $container-border;
			border-radius: 0 4px 4px 0;
		}

		&.active {
			color: $font-light;
			background-color: $primary-state;
			border-color: $primary-state;
		}

		@media (any-hover: hover) {
			&:hover {
				cursor: pointer;
				color: $font-light;
				background-color: $hover-state;
				border-color: $hover-state;
				border-left: 2px solid $hover-state;
				border-right: 2px solid $hover-state;
			}
		}

		&:active {
			color: $font-light;
			background-color: $tapped-state;
			border-color: $tapped-state;
		}
	}

	@media (min-width: $breakpoint-mid) {
		height: 48px;
	}
}
</style>
